interface OnboardingBuildStepsProps {
  /** Ordered step labels, drawn left-to-right and evenly spaced. */
  steps: readonly string[];
  /** How many leading steps are checked (filled). */
  completed: number;
}

const StepCircle = ({ checked }: { checked: boolean }) =>
  checked ? (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="drop-shadow-[0_2px_4px_rgba(0,0,0,0.25)]"
      aria-hidden
    >
      <circle cx="12" cy="12" r="12" fill="#bc9cf2" />
      <path
        d="M7 13L10 16L17 9"
        stroke="#130c2d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="drop-shadow-[0_2px_4px_rgba(0,0,0,0.25)]"
      aria-hidden
    >
      <circle cx="12" cy="12" r="11" fill="#130c2d" stroke="#bc9cf2" strokeWidth="2" />
    </svg>
  );

/**
 * Horizontal progress tracker for the building screen: evenly spaced check
 * circles joined by a connector line, with a label under each. The connector
 * runs behind the (opaque) circles from the first to the last circle centre.
 */
export const OnboardingBuildSteps = ({ steps, completed }: OnboardingBuildStepsProps) => {
  // Circle centres sit at (i + 0.5) / steps.length across the row, so the
  // connector spans from the first to the last centre.
  const inset = `${50 / steps.length}%`;

  return (
    <div className="relative flex w-full">
      <div
        className="absolute top-3 h-1 -translate-y-1/2 bg-[#7b59b2]"
        style={{ left: inset, right: inset }}
      />
      {steps.map((label, i) => (
        <div key={label} className="relative z-10 flex flex-1 flex-col items-center gap-3">
          <StepCircle checked={i < completed} />
          <span className="text-sm leading-none font-medium text-white">{label}</span>
        </div>
      ))}
    </div>
  );
};
